export default "__VITE_ASSET__BYNd4Bb9__"